import React from 'react';
import { WAYS } from '../data/mock';
import { Check } from 'lucide-react';

const WaysToTransform = () => (
  <section className="py-20 md:py-24 bg-white">
    <div className="max-w-[1200px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <div>
        <p className="uppercase text-sm tracking-[0.25em] text-slate-500 mb-3">Empower Change, Embrace Impact</p>
        <h2 className="heading-display text-4xl md:text-5xl font-bold text-slate-900 leading-tight">
          3 Simple Ways to <br /> <span className="text-[#F97559]">Transform Lives</span>
        </h2>
        <div className="mt-5 flex items-center gap-1">
          <span className="w-10 h-0.5 bg-[#F97559]" />
          <span className="w-2 h-2 rounded-full bg-[#F97559]" />
          <span className="w-10 h-0.5 bg-[#F97559]" />
        </div>
      </div>
      <div className="bg-[#2BBECF] p-8 md:p-10 rounded-sm space-y-4">
        {WAYS.map((w, i) => (
          <div key={i} className="flex items-center gap-5 group cursor-pointer">
            <div className="w-14 h-14 bg-white grid place-items-center text-[#F97559] shrink-0 transition-transform group-hover:scale-110">
              <Check strokeWidth={3} />
            </div>
            <p className="text-white text-lg md:text-xl font-semibold">{w}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WaysToTransform;
